module.exports = __webpack_public_path__ + "static/media/domestic-care.e13d8c52.jpg";